import { axiosResolution } from "../api/axiosResolution";

/**
 * Mengambil daftar transaksi dari resolution-svc berdasarkan client_email atau client_phone
 * @param {Object} params
 * @param {string} [params.clientEmail]
 * @param {string} [params.clientPhone]
 * @param {string} [params.startTransactionDate] - created_at ticket
 */
export const serviceGetTransactions = async ({
  clientEmail,
  clientPhone,
  startTransactionDate,
}) => {
  try {
    const params = new URLSearchParams();
    if (clientEmail) params.append("client_email", clientEmail.trim());
    if (clientPhone) params.append("client_phone", clientPhone.trim());
    if (startTransactionDate) params.append("start_transaction_date", startTransactionDate);

    const response = await axiosResolution.get(`/api/v1/transactions?${params.toString()}`);
    return response;
  } catch (error) {
    if (!error.response) {
      return { status: "No Server Response", error };
    }
    return error.response;
  }
};

/**
 * Resolve transaksi ke resolution-svc
 * @param {Object} params
 * @param {string} params.crmTicketId
 * @param {string} params.orderId
 * @param {string} params.pc
 */
export const serviceResolveTransaction = async ({ crmTicketId, orderId, pc }) => {
  try {
    const response = await axiosResolution.put("/api/v1/transactions/resolver", {
      crm_ticket_id: crmTicketId,
      order_id: orderId,
      pc: pc,
    });
    return response;
  } catch (error) {
    if (!error.response) {
      return { status: "No Server Response", error };
    }
    return error.response;
  }
};
